// extracted by mini-css-extract-plugin
export default {"list":"RestaurantList_list__uN14e","empty":"RestaurantList_empty__1ONKm","emptyIcon":"RestaurantList_emptyIcon__ExMAi","divider":"RestaurantList_divider__F4rP5"};